import { Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Dismissable, PageHeaderCommands } from '../page-header.commands';
import { Page } from '../../../models/page';
import { Teacher } from 'src/app/models/teacher';
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { Subject, map, takeUntil } from 'rxjs';
import { TeacherStore } from 'src/app/stores/teacher.store';

@Component({
  selector: 'app-resources-menu',
  templateUrl: './resources-menu.component.html',
  styleUrls: ['./resources-menu.component.scss']
})
export class ResourcesMenuComponent implements OnInit, Dismissable {

  private teacher: Teacher
  ngUnsubscribeTeacher = new Subject();
  
  popover: PopoverController;
  isSelected: boolean = false
  url: string = ''

  constructor(navParams: NavParams,
              private teacherProvider: TeacherProvider,
              public commands: PageHeaderCommands,
              private teacherStore: TeacherStore) {
    
                this.teacher = this.teacherProvider.teacher;
                this.teacherStore.state$
                    .pipe(takeUntil(this.ngUnsubscribeTeacher))
                    .subscribe(() => {
                      this.teacher = this.teacherProvider.teacher;
                    });

    this.popover = navParams.get('popoverController');
  }

  ngOnInit() {
  }
  
  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

  dismiss() {
    this.popover.dismiss()
  }

  resourcePages(): Page[] {
    const resourcePages = new Array<Page>()
    this.teacher.resourcePages.forEach( (page: Page) => {
      if (0 === page.parentId) {
        resourcePages.push(page)
      }
    })
    return resourcePages
  }

  public trackByUuid(index: number, page: Page) {
    return page.uuid;
  }
}
